// src/pages/Checkout.jsx
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearCart } from "../features/cart/cartSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function Checkout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = useSelector((state) => state.cart.items || []);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const subtotal = items.reduce(
    (sum, it) => sum + (parseFloat(it.price) || 0) * (it.quantity || 1),
    0
  );
  const shipping = subtotal > 0 ? 15 : 0; // مثال: شحن ثابت
  const total = subtotal + shipping;

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handlePlaceOrder = (e) => {
    e.preventDefault();

    // بسيط: تحقق سريع
    if (!form.name || !form.email || !form.address) {
      Swal.fire({
        icon: "warning",
        title: "Please complete shipping details",
      });
      return;
    }

    // هنا ممكن ترسل الطلب للـ API — حالياً نعمل محاكاة نجاح
    Swal.fire({
      icon: "success",
      title: "Order Placed!",
      html: `<strong>Thank you, ${form.name}.</strong><p>Your order total is $${total.toFixed(
        2
      )}.</p>`,
      showConfirmButton: true,
    }).then(() => {
      // تفريغ الكارت
      dispatch(clearCart());
      localStorage.removeItem("cart");
      navigate("/");
    });
  };

  if (items.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h3>Your cart is empty 🛒</h3>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <h2 className="text-center main-color mb-4">Checkout</h2>

      <div className="row">
        {/* نموذج بيانات الشحن */}
        <div className="col-md-6">
          <div className="card p-4 mb-4">
            <h5 className="main-color">Shipping Details</h5>
            <form onSubmit={handlePlaceOrder}>
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="John Doe"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="email@example.com"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Phone</label>
                <input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="+1 234 567 890"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Address</label>
                <textarea
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  className="form-control"
                  rows="3"
                  placeholder="Street, City, ZIP, Country"
                  required
                />
              </div>

              <button type="submit" className="btn btn-outline-custom w-100">
                Place Order — ${total.toFixed(2)}
              </button>
            </form>
          </div>
        </div>

        {/* ملخص الطلب */}
        <div className="col-md-6">
          <div className="card p-4 mb-4">
            <h5 className="main-color">Order Summary</h5>
            {items.map((it) => (
              <div key={it.id} className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center gap-3">
                  <img src={it.image} alt={it.name} style={{ width: 60, height: 60, objectFit: "cover" }} className="rounded" />
                  <div>
                    <div className="fw-bold">{it.name}</div>
                    <div className="text-muted small">Qty: {it.quantity || 1}</div>
                  </div>
                </div>
                <div>${((parseFloat(it.price) || 0) * (it.quantity || 1)).toFixed(2)}</div>
              </div>
            ))}

            <hr />
            <div className="d-flex justify-content-between">
              <div>Subtotal</div>
              <div>${subtotal.toFixed(2)}</div>
            </div>
            <div className="d-flex justify-content-between">
              <div>Shipping</div>
              <div>${shipping.toFixed(2)}</div>
            </div>
            <hr />
            <div className="d-flex justify-content-between fw-bold">
              <div className="main-color">Total</div>
              <div className="main-color">${total.toFixed(2)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Checkout;
